import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const ClientsComponent = lazy(() =>
  import("@/modules/insights/pages/clients").then((module) => ({
    default: module.ClientsTab,
  }))
);

export const Route = createFileRoute(
  "/(auth)/_headed/insights/_layout/clients"
)({
  component: ClientsComponent,
});
